import { Order, OrderStatusEnum } from "@/interfaces/domain/Order";

export const getParsedOrderInfo = (order: Order) => {
  const store = order?.estabelecimento;
  const items = order?.itens;
  const address = order?.endereco_cliente;
  const shipmentValue = order?.detalhes_pagamento?.frete;
  const subtotal = order?.detalhes_pagamento?.subtotal;
  const total = order?.valor_total;
  const separatorName = order?.separador?.nome;
  const deliverymanName = order?.entregador?.nome;
  const voucherDetails = order?.detalhes_desconto;
  const serviceTaxValue = order?.detalhes_pagamento?.valor_taxa_servico;

  const isInProcess = ![OrderStatusEnum.CANCELED, OrderStatusEnum.SCHEDULED].includes(
    order?.status
  );

  const isScheduled = OrderStatusEnum.SCHEDULED === order?.status;
  return {
    store,
    items,
    address,
    shipmentValue,
    subtotal,
    total,
    serviceTaxValue,
    voucherDetails,
    separatorName,
    deliverymanName,
    isInProcess,
    isScheduled,
  };
};
